import { useContext } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  Chip,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import {
  enableInsights,
  enableJira,
  enableZendesk,
  enableMailReply,
} from "../../utils/config";
import { getDateTime } from "../../utils/data";
import ReviewDetails from "./ReviewDetails";
import { UserData } from "../../model";
import { ReactNode } from "react";
import { appLogger } from "../../utils";

import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { useNavigate } from "react-router-dom";

interface ReportAccordianProps {
  reportsTicketsData: any;
  reportsTicketsDataIndex: any;
  // index: number;
  // pageType: string;
  renderProVersion: (productId: string, productVersion: string) => ReactNode;
  // renderSentiment: (sentiment: string) => ReactNode;
  // getSignedUrl: (url: string) => void;
  // handleMailDrawerOpen: (index: number) => void;
  // handleDrawerOpen: (index: number) => void;
  // inViewRef: (node?: Element | null | undefined) => void;
  topic: string;
}

const ReviewReportAccordian = ({
  reportsTicketsData,
  reportsTicketsDataIndex,
  // index,
  // pageType,
  renderProVersion,
  topic,
}: // renderSentiment,
// getSignedUrl,
// handleMailDrawerOpen,
// handleDrawerOpen,
// inViewRef,
ReportAccordianProps) => {
  const navigate = useNavigate();
  const { enabledFeatures } = useContext(UserContext) as UserLoginInfo;
  const handleRedirect = (type: string) => {
    navigate("/tickets", {
      state: {
        tab: type === "reply" ? 1 : 0,
      },
    });
  };
  const handleReadMore = (type: string) => {
    navigate("/tickets", {
      state: {
        tab: type === "reply" ? 1 : 0,
        feedbackData: reportsTicketsData,
        correlatedValue: topic,
      },
    });
  };

  const renderStatus = (status: string) => {
    let statusColor = { color: "", background: "" };

    if (status === "pending response") {
      statusColor = { color: "#FF8652", background: "rgb(255 134 82 / 10%)" };
    }

    if (status === "open") {
      statusColor = { color: "#2858D3", background: "rgba(40, 88, 211, 0.1)" };
    }

    if (status === "replied") {
      statusColor = { color: "#3EB458", background: "rgba(62, 180, 88, 0.1)" };
    }

    if (status === "closed") {
      statusColor = {
        color: "#A0A5B1",
        background: "rgba(160, 165, 177, 0.1)",
      };
    }

    return (
      <Chip
        label={status}
        sx={{
          textTransform: "uppercase",
          ...statusColor,
        }}
      />
    );
  };
  const handleRedirectReplyScreen = () => {
    navigate(`/tickets`);
  };
  return (
    <Accordion defaultExpanded>
      <AccordionSummary>
        <Typography className="user-mail">
          {reportsTicketsData.userId}Anonymous user
        </Typography>
        <Typography className="version" sx={{ pl: 2 }}>
          Product :
          <span>
            {renderProVersion(
              reportsTicketsData.productId || "",
              reportsTicketsData.productVersion || ""
            )}
          </span>
          <span>, {reportsTicketsData.productVersion || ""}</span>
        </Typography>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
          className="ratings"
        >
          <Typography className="version">Rating: </Typography>
          <Rating
            className={`ratings-clr-${reportsTicketsData.StarRating}`}
            name="read-only"
            value={reportsTicketsData.StarRating || 0}
            readOnly
          />
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
          className="ratings"
        >
          <Typography className="version">Sentiment: </Typography>
          <Chip
            label={reportsTicketsData.sentiment}
            color="primary"
            variant="outlined"
            className="bug-chip-text"
          />
        </Stack>
        <Typography className="created-date-header">Modified on :</Typography>

        <Typography className="last-modified-date">
          {" "}
          {reportsTicketsData.ReviewLastUpdateDateandTime
            ? getDateTime(reportsTicketsData.ReviewLastUpdateDateandTime)
            : ""}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <ReviewDetails
          reportsTicketsDataIndex={reportsTicketsDataIndex}
          datas={reportsTicketsData}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 1,
            pl: 0,
          }}
        >
          <Box
            sx={{
              marginRight: "auto",
              display: "flex",
              alignItems: "center",
              paddingRight: 1,
            }}
          >
            <Typography className="modified-date-header">
              Created on :
            </Typography>
            <Typography className="created-date">
              {" "}
              {reportsTicketsData.createdOn
                ? getDateTime(Number(reportsTicketsData.createdOn))
                : ""}
            </Typography>
          </Box>
          {/* {reportsTicketsData.extSysVal &&
          (enableJira || enableZendesk) &&
          (enabledFeatures?.enableJira || enabledFeatures?.enableZendesk) ? (
            <Box className="read-more-link" style={{ display: "inline-block" }}>
              <Typography
                onClick={() =>
                  window.open(
                    `${reportsTicketsData.extSysVal?.url || ""}`,
                    "_blank"
                  )
                }
              >
                {reportsTicketsData.extSysVal.type} -{" "}
                {reportsTicketsData.extSysVal.id}
              </Typography>
            </Box>
          ) : (
            <></>
          )} */}
          {/* <Box className="read-more-link" style={{ display: "inline-block" }}>
            <Typography onClick={() => handleReadMore("reply")}>
              <Badge color="primary">Reply</Badge>
            </Typography>
          </Box> */}

          {/* <Box
            id="read-more"
            className="read-more-link"
            style={{ display: "inline-block" }}
          >
            <Typography onClick={() => handleReadMore("read")}>
              read more
            </Typography>
          </Box> */}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default ReviewReportAccordian;
